import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth";

export function LoginPage() {
  const { configured, sessionToken, isAdmin, signInWithApple, loading } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!loading && sessionToken && isAdmin) {
    return <Navigate to="/" replace />;
  }

  async function onAppleClick() {
    setBusy(true);
    setError(null);
    try {
      await signInWithApple();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign-in failed.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="panel login-card stack">
        <div className="login-hero">
          <div className="logo">₱</div>
          <h1>Catalog admin</h1>
          <p>walletadmin.pambayad.com</p>
        </div>

        <p className="muted" style={{ margin: 0 }}>
          Manage Institutions, Networks, and Card Products in CloudKit Public. Cosmetic data only —
          no expense or wallet financial data.
        </p>

        {!configured && (
          <div className="error-banner">
            Missing <code>VITE_APPLE_CLIENT_ID</code> (Services ID). Add it to{" "}
            <code>.env.local</code> and rebuild.
          </div>
        )}

        {error && <div className="error-banner">{error}</div>}

        <button
          className="btn btn-primary"
          type="button"
          disabled={!configured || busy || loading}
          onClick={() => void onAppleClick()}
        >
          {busy ? "Signing in…" : "Sign in with Apple"}
        </button>

        <p className="muted" style={{ fontSize: "0.85rem", margin: 0 }}>
          Access is limited to Apple accounts listed in <code>APPLE_ADMIN_SUBS</code> /{" "}
          <code>APPLE_ADMIN_EMAILS</code> on the Worker.
        </p>
      </div>
    </div>
  );
}
